export const microsoftGraph = {
  defaultScope: 'https://graph.microsoft.com/.default',
  meEndpoint: 'https://graph.microsoft.com/v1.0/me',
  photoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};

export const roles = {
  MANAGER: 'manager',
};

export const queryKeys = {
  EMPLOYEES_QUERY_KEY: 'employees',
  SERVICELINES_QUERY_KEY: 'servicelines',
  TEAMS_QUERY_KEY: 'teams',
  ROLES_QUERY_KEY: 'roles',
  NON_TEAM_LEADERS_QUERY_KEY: 'non team leaders',
  NON_SERVICE_LINE_LEADERS_QUERY_KEY: 'non service line leaders',
  CLIENTS_QUERY_KEY: 'clients',
  PROJECTS_QUERY_KEY: 'projects',
  CLIENT_PROJECTS_QUERY_KEY: 'clients projects',
  PRIORITY_QUERY_KEY: 'priorities',
  MANAGER_PROXY_QUERY_KEY: 'manager proxies',
  REPORTING_EMPLOYEES_QUERY_KEY: 'reporting employees',
  IS_MANAGER_QUERY_KEY: 'is manager',
  PROXY_USER_OPTIONS_QUERY_KEY: 'proxy user options',
};
